import Swiper, { Autoplay, Pagination } from 'swiper'

import { mdBreakpoint } from "../utils/breakpoints"

Swiper.use([Autoplay, Pagination])

function initFeaturePanels() {

  const featurePanelSwipers = Array.from(document.querySelectorAll('.js-feature-panel-swiper'))

  featurePanelSwipers.forEach(featurePanelSwiper => {

    const featurePanelCols = Array.from(featurePanelSwiper.querySelectorAll('.js-feature-panel-col'))

    //Check if one or more feature panel columns have a visible label, if true add the class '-item-with-label-visible' to the block so that feature panel column siblings' top padding matches
    const featurePanelColumnLabels = () => {
      if (featurePanelSwiper.classList.contains('-carousel-mobile') || mdBreakpoint.matches) {

        //Reset for when featurePanelColumnLabels gets called after resize
        featurePanelSwiper.classList.remove('-item-with-label-visible')

        featurePanelCols.forEach(panelCol => {
          if (panelCol.classList.contains('-label-visible')) {
            featurePanelSwiper.classList.add('-item-with-label-visible')
          }
        })

      }
    }

    //Invoke on page load
    featurePanelColumnLabels()


    let swiper = Swiper
    let swiperInitialised = false
    let mdColCount
    const paginationEl = featurePanelSwiper.querySelector('.js-feature-panel-pagination')

    if (featurePanelSwiper.classList.contains('-four-col')) {
      mdColCount = 4
    } else if (featurePanelSwiper.classList.contains('-three-col')) {
      mdColCount = 3
    } else if (featurePanelSwiper.classList.contains('-two-col')) {
      mdColCount = 2
    } else {
      mdColCount = 1
    }

    const initSwiper = () => {
      swiperInitialised = true

      swiper = new Swiper(featurePanelSwiper, {
        loop: false,
        speed: 800,
        grabCursor: true,
        autoplay: {
          delay: 8000
        },
        watchOverflow: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: mdColCount,
          }
        }
      })
    }

    const destroySwiper = () => {
      swiper.destroy()
      paginationEl.style.display = "none"
      swiperInitialised = false
    }

    //Invoke on page load
    if (mdBreakpoint.matches &&
      swiperInitialised === false &&
      featurePanelSwiper.classList.contains('-carousel-desktop')
    ) {
      initSwiper()
    } else if (!mdBreakpoint.matches &&
      swiperInitialised === false &&
      featurePanelSwiper.classList.contains('-carousel-mobile')
    ) {
      initSwiper()
    }

    //Init or destroy after resize
    const initOrDestroy = () => {

      //Check if swiper should be destroyed
      if (mdBreakpoint.matches &&
        swiperInitialised === true &&
        !featurePanelSwiper.classList.contains('-carousel-desktop')
      ) {
        destroySwiper()
      } else if (!mdBreakpoint.matches &&
        swiperInitialised === true &&
        !featurePanelSwiper.classList.contains('-carousel-mobile')
      ) {
        destroySwiper()
      }

      //Check if swiper should be initialised
      if (mdBreakpoint.matches &&
        swiperInitialised === false &&
        featurePanelSwiper.classList.contains('-carousel-desktop')
      ) {
        initSwiper()
        paginationEl.style.display = "flex"
        swiperInitialised = true
      } else if (!mdBreakpoint.matches &&
        swiperInitialised === false &&
        featurePanelSwiper.classList.contains('-carousel-mobile')
      ) {
        initSwiper()
        paginationEl.style.display = "flex"
        swiperInitialised = true
      }
    }

    const invokeAfterResize = () => {
      let rtime
      let timeout = false
      const timeoutDuration = 200

      window.addEventListener('resize', () => {
        rtime = new Date()
        if (timeout === false) {
          timeout = true
          setTimeout(resizeEnd, timeoutDuration)
        }
      })

      const resizeEnd = () => {
        if (new Date() - rtime < timeoutDuration) {
          setTimeout(resizeEnd, timeoutDuration)
        } else {
          timeout = false
          featurePanelColumnLabels()
          initOrDestroy()
        }
      }
    }
    invokeAfterResize()

  })
}
initFeaturePanels()
